<template>
  <div>
    <el-row style="margin-bottom: 20px;">
      <el-col :span="24">
        <el-button
          type="info"
          icon="el-icon-back"
          size="mini"
          @click="$router.push({path: `/app/tenants/${$route.params.id}/customers`})">
          {{ $t('settings.backToCustomers') }}
        </el-button>
      </el-col>
    </el-row>

    <h2>{{ $t('settings.createCustomer') }}</h2>

    <customer-form-component
      mode="create"
      @submit="onSubmit"
      :error="responseError"
      :loading="loading">
    </customer-form-component>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import CustomerFormComponent from '@/components/settings/customer/CustomerForm';

const tenantStateMappers = createNamespacedHelpers('tenant');

export default {
  name: "CreateTenantCustomer",
  components: {CustomerFormComponent},
  data() {
    return {
      loading: false,
      responseError: '',
    }
  },
  methods: {
    ...tenantStateMappers.mapActions(['createCustomer']),
    onSubmit(customer) {
      this.loading = true;
      // Add tenantId to the customer
      customer.tenantId = this.$route.params.id;

      this.createCustomer({
        tenantId: this.$route.params.id,
        customer
      }).then(() => {
        this.$message.info(this.$t('settings.customerCreated'));
        setTimeout(() => this.$router.replace({path: `/app/tenants/${this.$route.params.id}/customers`}), 200);
      }).catch((error) => {
        if (error.response && error.response.status === 409) {
          this.responseError = this.$t('settings.customerExists');
          this.$message({
            message: this.$t('settings.customerExists'),
            type: 'error',
            duration: 10000,
          });
        } else {
          this.responseError = this.$t('settings.genericHttpError');
          this.$message({
            message: this.$t('settings.genericHttpError'),
            type: 'error',
            duration: 10000,
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
